"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandC2D = exports.OtaDeviceManageCommand = exports.OtaDeviceManageParams = exports.OtaTargetVersion = exports.OtaBuildFile = exports.OTA_MEMORY_REGIONS = exports.SetTapTypeAppCommand = exports.SetLocationAliasCommand = exports.ResetCommand = exports.ResetComponent = exports.PurgeCommand = exports.PurgeAction = exports.PurgeComponent = exports.FlushCommand = exports.FlushAction = exports.FlushComponent = exports.CalibrateCommand = exports.CalibrateAction = exports.CalibrateComponent = exports.RestartCommand = exports.RestartComponent = void 0;
const effect_1 = require("effect");
const SemVer = __importStar(require("../../../../semver"));
const RoutineSequence = __importStar(require("./routine-sequence"));
const _1 = require(".");
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge.Command';
exports.RestartComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('lcd')).annotations({
    identifier: `${NAMESPACE}.RestartComponent`,
});
exports.RestartCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('restart')),
    params: effect_1.Schema.Struct({
        component: exports.RestartComponent,
    }),
}).annotations({
    identifier: `${NAMESPACE}.RestartCommand`,
    title: 'Restart Command',
    description: 'Instructs the device to restart the specified component',
});
exports.CalibrateComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('boiling', 'light')).annotations({
    identifier: `${NAMESPACE}.CalibrateComponent`,
});
exports.CalibrateAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'start', 'exit')).annotations({
    identifier: `${NAMESPACE}.CalibrateAction`,
});
exports.CalibrateCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('calibrate')),
    params: effect_1.Schema.Struct({
        component: exports.CalibrateComponent,
        action: exports.CalibrateAction,
    }),
}).annotations({
    identifier: `${NAMESPACE}.CalibrateCommand`,
    title: 'Calibrate Command',
    description: 'Instructs the device to start calibrating the specified component',
});
exports.FlushComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('tank', 'filter')).annotations({
    identifier: `${NAMESPACE}.FlushComponent`,
});
exports.FlushAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'preRun', 'start', 'pause', 'resume', 'finish', 'exit')).annotations({
    identifier: `${NAMESPACE}.FlushAction`,
});
exports.FlushCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('flush')),
    params: effect_1.Schema.Struct({
        component: exports.FlushComponent,
        action: exports.FlushAction,
    }),
}).annotations({
    identifier: `${NAMESPACE}.FlushCommand`,
    title: 'Flush Command',
    description: 'Instructs the device to start flushing the specified component',
});
exports.PurgeComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('co2')).annotations({
    identifier: `${NAMESPACE}.PurgeComponent`,
});
exports.PurgeAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'start', 'pause', 'resume', 'finish', 'exit')).annotations({
    identifier: `${NAMESPACE}.PurgeAction`,
});
exports.PurgeCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('purge')),
    params: effect_1.Schema.Struct({
        component: exports.PurgeComponent,
        action: exports.PurgeAction,
    }),
}).annotations({
    identifier: `${NAMESPACE}.PurgeCommand`,
    title: 'Purge Command',
    description: 'Instructs the device to start purging the specified component',
});
exports.ResetComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('filter_counter', 'co2_counter', 'energy_usage', 'co2_sensor_zero_flow')).annotations({
    identifier: `${NAMESPACE}.ResetComponent`,
});
exports.ResetCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('reset')),
    params: effect_1.Schema.Struct({
        component: exports.ResetComponent,
    }),
}).annotations({
    identifier: `${NAMESPACE}.ResetCommand`,
    title: 'Reset Command',
    description: 'Instructs the device to reset the specified component',
});
exports.SetLocationAliasCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('location_alias.set'),
    params: effect_1.Schema.Struct({
        locationAlias: _1.LocationAlias,
    }),
}).annotations({
    identifier: `${NAMESPACE}.SetLocationAliasCommand`,
    title: 'Set Location Alias',
    description: 'Instructs the device to set its location alias to the given value',
});
exports.SetTapTypeAppCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('tap_type_app.set'),
    params: effect_1.Schema.Struct({
        tapTypeApp: _1.TapTypeApp,
    }),
}).annotations({
    identifier: `${NAMESPACE}.SetTapTypeAppCommand`,
    title: 'Set Tap Application Type',
    description: 'Instructs the device to set the tap application type to the given value',
});
exports.OTA_MEMORY_REGIONS = ['Wifi', 'Core', 'Gfx'];
exports.OtaBuildFile = effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString).annotations({
    identifier: `${NAMESPACE}.OtaBuildFile`,
    description: 'The file name of the build artifact to flash to a memory region, ' +
        'or null to leave the region out of this update',
});
exports.OtaTargetVersion = effect_1.Schema.NullOr(SemVer.SemVer).annotations({
    identifier: `${NAMESPACE}.OtaTargetVersion`,
    description: 'The version the memory region should end up on, ' +
        'or null to leave the region out of this update',
});
exports.OtaDeviceManageParams = effect_1.Schema.Struct({
    buildFileWifi: exports.OtaBuildFile,
    targetVersionWifi: exports.OtaTargetVersion,
    buildFileCore: exports.OtaBuildFile,
    targetVersionCore: exports.OtaTargetVersion,
    buildFileGfx: exports.OtaBuildFile,
    targetVersionGfx: exports.OtaTargetVersion,
    forceTargetVersion: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'When true the device flashes the requested target version even if a later build ' +
            'artifact exists, which is what makes a rollback possible. When false the device ' +
            'uses the later artifact instead',
    }),
})
    .pipe(effect_1.Schema.filter(params => {
    // A region is either fully specified or left out entirely: the device has no way to
    // resolve one half of the pair on its own.
    const unpaired = exports.OTA_MEMORY_REGIONS.filter(region => (params[`buildFile${region}`] === null) !== (params[`targetVersion${region}`] === null));
    if (unpaired.length > 0) {
        return `${unpaired.join(', ')}: a build file and a target version must both be given, or both be null`;
    }
    // Every region left out means "check all three and take whatever is newer", which is the
    // opposite of forcing a specific version.
    const noRegionRequested = exports.OTA_MEMORY_REGIONS.every(region => params[`buildFile${region}`] === null);
    if (noRegionRequested && params.forceTargetVersion) {
        return 'forceTargetVersion requires at least one memory region to be specified';
    }
    return undefined;
}))
    .annotations({
    identifier: `${NAMESPACE}.OtaDeviceManageParams`,
    description: 'The memory regions to update. Leaving every region null asks the device to check all ' +
        'three and update the ones with a later build artifact',
});
exports.OtaDeviceManageCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('ota.device_manage'),
    params: exports.OtaDeviceManageParams,
}).annotations({
    identifier: `${NAMESPACE}.OtaDeviceManageCommand`,
    title: 'Device Managed OTA Update',
    description: 'Instructs the device to trigger and manage OTA updates across its three memory regions. ' +
        'The device sequences the individual updates itself, including the power cycles between ' +
        'them, so the cloud is only a gateway for this command',
});
exports.CommandC2D = effect_1.Schema.Union(exports.RestartCommand, exports.CalibrateCommand, exports.FlushCommand, exports.PurgeCommand, exports.ResetCommand, exports.SetLocationAliasCommand, exports.SetTapTypeAppCommand, exports.OtaDeviceManageCommand).annotations({ identifier: `${NAMESPACE}.CommandC2D` });
//# sourceMappingURL=command.js.map